import Vue from "vue";
import { apiErrorHandler, oktaAxios as axios } from "@/vue/api/config";

import flatten from "flat";

//defines fwd rules conditions.  filter all call farwarding rules based on these conditions.
var fwdRulesCondition = [
  { ruleType: "ANYTIME_RULE", ruleCondition: "BUSY" },
  { ruleType: "ANYTIME_RULE", ruleCondition: "NO_ANSWER" },
  { ruleType: "ANYTIME_RULE", ruleCondition: "OUTAGE" },
];

function formatExtensions(extensions, path) {
  if (path === "call_waiting") {
    return extensions.map((ext) => {
      ext = flatten(ext, { delimiter: "_" });
      ext.details_callWaitingDisabled =
        ext.details_callWaitingDisabled.toString();
      return ext;
    });
  }

  if (path == "forwarding_rules") {
    return Vue.lodash.orderBy(
      Vue.lodash.reduce(
        extensions,
        (acc, ext) => {
          ext = Vue.lodash.pick(ext, [
            "subscriptionId",
            "extensionNumber",
            "serviceType",
            "branch.name",
            "callerIdFirstName",
            "callerIdLastName",
            "user.loginId",
            "primaryDID",
            "forwardingRules",
          ]);

          if (!ext.forwardingRules || ext.forwardingRules.length === 0) {
            return acc;
          }

          // filter out forwarding rules based on forwarding rules condition before flattening
          // order forwarding rules by contidion
          ext.forwardingRules = Vue.lodash.orderBy(
            ext.forwardingRules,
            ["ruleCondition"],
            ["asc"]
          );

          // pick just required fwd rules defined in fwdRulesCondition
          ext.forwardingRules = Vue.lodash.intersectionWith(
            ext.forwardingRules,
            fwdRulesCondition,
            Vue.lodash.isMatch
          );

          ext.forwardingRules = Vue.lodash.forEach(
            ext.forwardingRules,
            (rule) => {
              if (rule.destinations) {
                // add destination field to all rules
                if (
                  rule.destinations.length > 0 &&
                  !rule.destinations[0].destination
                )
                  rule.destinations[0].destination = "";
                //change NUMBER to EXTENSION so it is user friendly
                if (
                  rule.destinations.length > 0 &&
                  rule.destinations[0].destinationType == "NUMBER"
                )
                  rule.destinations[0].destinationType = "EXTENSION";
              }
            }
          );

          if (ext.forwardingRules.length > 0) {
            //flatten extension
            ext = flatten(ext, { delimiter: "_" });
            acc.push(ext);
          }

          return acc;
        },
        []
      ),
      ["serviceType", "extensionNumber"],
      ["asc", "asc"]
    );
  } else if (path == "multi_call_handling") {
    return Vue.lodash.orderBy(
      Vue.lodash.map(extensions, (ext) => {
        //flatten extension
        ext = flatten(ext, { delimiter: "_" });

        //change max concurent calls to string because tabulator doesnt accept integers for validation rule => in:1|2|3|
        if (ext.details_maxConcurrentCalls) {
          ext = Vue.lodash.pick(ext, [
            "extensionNumber",
            "subscriptionId",
            "primaryDID",
            "callerIdFirstName",
            "callerIdLastName",
            "details_maxConcurrentCalls",
          ]);
          ext.details_maxConcurrentCalls =
            ext.details_maxConcurrentCalls.toString();
        }

        return ext;
      }),
      ["serviceType", "extensionNumber"],
      ["asc", "asc"]
    );
  } else return extensions;
}

function formatUpdateResult(response) {
  const result = { success: [], error: [] };
  response.forEach((tapResponseEntity) => {
    if (tapResponseEntity.operationResult.success) {
      result.success.push(tapResponseEntity);
      return;
    }
    result.error.push(tapResponseEntity);
  });
  return result;
}

export const updateext = {
  state: {
    extensions: [],
    updateExtResults: { success: [], error: [] },
    selectedExtensionProperty: null,
  },
  getters: {
    getExtensions: (state) => {
      return state.extensions;
    },
    getUpdateExtResults: (state) => {
      return state.updateExtResults;
    },
    getSelectedExtensionProperty: (state) => {
      return state.selectedExtensionProperty;
    },
  },
  mutations: {
    SET_EXTENSIONS: (state, payload) => {
      state.extensions = payload;
    },
    SET_UPDATE_EXT_RESULTS: (state, payload) => {
      state.updateExtResults = payload;
    },
    SET_SELECTED_EXTENSION_PROPERT: (state, payload) => {
      state.selectedExtensionProperty = payload;
    },
  },
  actions: {
    setSelectedExtensionProperty: ({ commit }, payload) => {
      commit("SET_SELECTED_EXTENSION_PROPERT", payload);
    },
    fetchExtensions: ({ commit, rootGetters }, payload) => {
      const customerId = rootGetters.getCustomer.cid;
      const pbxId = rootGetters.getCustomer.pbx.id;

      if (payload.path == "call_waiting") {
        return axios
          .get(
            `/v1/customers/${customerId}/pbxes/${pbxId}/extensions/call-waiting`
          )
          .then((response) => {
            commit(
              "SET_EXTENSIONS",
              formatExtensions(response.data, payload.path)
            );
            payload.success(
              "Retrieved " + response.data.length + " extensions."
            );
          })
          .catch((error) => {
            console.error(error);
            payload.error(error.message);
          });
      }

      if (payload.path == "multi_call_handling") {
        return axios
          .get(`/v1/customers/${customerId}/pbxes/${pbxId}/extensions/allowed`)
          .then((response) => {
            commit(
              "SET_EXTENSIONS",
              formatExtensions(response.data, payload.path)
            );
            payload.success(
              "Retrieved " + response.data.length + " extensions."
            );
          })
          .catch((error) => {
            console.error(error);
            payload.error(error.message);
          });
      }

      if (payload.path == "forwarding_rules") {
        return axios
          .get(
            `/v1/customers/${customerId}/pbxes/${pbxId}/extensions/forwarding-rules`
          )
          .then((response) => {
            const extensionsWithForwardingRules = response.data.map(
              ({ extension, forwardingRules }) => {
                extension.forwardingRules = forwardingRules;
                return extension;
              }
            );
            commit(
              "SET_EXTENSIONS",
              formatExtensions(extensionsWithForwardingRules, payload.path)
            );
            payload.success(
              "Retrieved " + response.data.length + " extensions."
            );
          })
          .catch((error) => {
            console.error(error);
            payload.error(error.message);
          });
      }

      if (payload.path == "recordingsettings") {
        return axios
          .get(
            `/v1/customers/${customerId}/pbxes/${pbxId}/extensions/recording-settings`
          )
          .then((response) => {
            commit(
              "SET_EXTENSIONS",
              formatExtensions(response.data, payload.path)
            );
            payload.success(
              "Retrieved " + response.data.length + " extensions."
            );
          })
          .catch((error) => {
            console.error(error);
            payload.error(error.message);
          });
      }
    },
    async patchExtensions(
      { commit, dispatch, rootGetters },
      { patchOperations }
    ) {
      const customerId = rootGetters.getCustomer.cid;
      const pbxId = rootGetters.getCustomer.pbx.id;

      const response = await axios
        .patch(
          `/v1/customers/${customerId}/pbxes/${pbxId}/extensions`,
          patchOperations
        )
        .catch(apiErrorHandler);

      commit("SET_UPDATE_EXT_RESULTS", formatUpdateResult(response.data));
      dispatch("sendAudit", {
        eventType: "UPDATE",
        objectType: "Update Extensions",
        objectKey: "Max Concurent Calls",
        details: patchOperations,
      });
      return response;
    },
    async updateForwardingRules({ commit, dispatch, rootGetters }, { data }) {
      const customerId = rootGetters.getCustomer.cid;
      const pbxId = rootGetters.getCustomer.pbx.id;

      const response = await axios
        .put(
          `/v1/customers/${customerId}/pbxes/${pbxId}/extensions/forwarding-rules`,
          data
        )
        .catch(apiErrorHandler);

      commit("SET_UPDATE_EXT_RESULTS", formatUpdateResult(response.data));
      dispatch("sendAudit", {
        eventType: "UPDATE",
        objectType: "Update Extensions",
        objectKey: "Forwarding Rules",
        details: data,
      });
      return response;
    },
    async updateRecordingSettings({ commit, dispatch, rootGetters }, { data }) {
      const customerId = rootGetters.getCustomer.cid;
      const pbxId = rootGetters.getCustomer.pbx.id;

      const response = await axios
        .put(
          `/v1/customers/${customerId}/pbxes/${pbxId}/extensions/recording-settings`,
          data
        )
        .catch(apiErrorHandler);

      commit("SET_UPDATE_EXT_RESULTS", formatUpdateResult(response.data));
      dispatch("sendAudit", {
        eventType: "UPDATE",
        objectType: "Update Extensions",
        objectKey: "Recording Settings",
        details: data,
      });
      return response;
    },
  },
};
